import React, { useState, useEffect, useRef } from 'react';
import './Certificates.css';
import { useTranslation } from 'react-i18next';
import Header from "../Header/Header.jsx";
import { Button, Col, Jumbotron, Nav, Row, Tab } from "react-bootstrap";
import ToastComponent from '../Toast/Toast';
import { Redirect } from "react-router-dom";
import { MdClose } from "react-icons/md";
import ThemeService from '../../services/ThemeService';
import LoadingCircle from './../LoadingCircle'
import ProfileService from '../../services/Profile/ProfileService';
import CertificateService from '../../services/Certificate/CertificateService';
import { CustomModal } from '../CustomModal/CustomModal';
import { FIRMAREMOTA_LOADING_AUTHORIZE_KEY, FIRMAREMOTA_LOADING_UNAUTHORIZE_KEY, KEYVAULT, KEYVAULT_LOADING_DELETING_KEY, KEYVAULT_LOADING_UPLOAD_KEY, LOADING_DELETING_PROCESS_KEY, NEBULA_LOADING_KEY, REDTRUST, REDTRUST_LOADING_AUTHORIZE_KEY, REDTRUST_LOADING_SYNCHRONIZE_KEY, REDTRUST_LOADING_UNAUTHORIZE_KEY, SOFTWARE, UANATACA, UANATACA_LOADING_AUTHORIZE_KEY, UANATACA_LOADING_UNAUTHORIZE_KEY, VALIDATEDID, VALIDATEDID_LOADING_AUTHORIZE_KEY, VALIDATEDID_LOADING_UNAUTHORIZE_KEY } from '../../services/signatureMethods/constants';
import { generateRedTrustAuthUri, 
    postPrivSignature, 
    deleteManagementSignature, 
    generateFirmaRemotaAuthUri, 
    generateFirmaRemotaStatusUri, 
    getManagementSignature, 
    postManagementSignature,
    putPrivSignature,
    generateRedTrustAuthStatusUri, 
    generateDeleteKeyVaultCertificateUri,
    generateuUploadCertificateKeyVaultUri, 
    generateDeleteSoftwareCertificateUri,
    generateUanatacaAuthUri,
    generateNebulaAuthMiddleUri,
    generateNebulaAuthEndUri,
    generateNebulaAuthUri,
    generateValidatedIdAuthUri} from '../../services/signatureMethods/customServiceSignature';
import { VIDMOBILEUSERID } from '../../assets/constants';
import NebulaCertificates from './Signatures/NebulaCertificates.component';
import FirmaRemotaCertificates from './Signatures/FirmaRemotaCertificates.component';
import UanatacaCertificates from './Signatures/UanatacaCertificates.component';
import RedTrustCertificates from './Signatures/RedTrustCertificates.component';
import SoftwareCertificates from './Signatures/SoftwareCertificates.component';
import KeyVaultCertificates from './Signatures/KeyVaultCertificates.component';
import ValidatedIdCertificates from './Signatures/ValidatedIdCertificates.component';

import warning from '../../assets/icons/warning-jumbotron.png';
import IvnosysCertificates from './Signatures/IvnosysCertificates.component';
import { ReactComponent as RefreshIcon } from '../../assets/icons/refresh.svg';

const Certificates = () => {
    const { t } = useTranslation();

    // ── State ────────────────────────────────────────────────────────────────
    const [oauthTokenB64] = useState(sessionStorage.getItem('oauthTokenB64'));
    const [language] = useState(localStorage.getItem('i18nextLng'));
    const [time, setTime] = useState(0);
    const [showError, setShowError] = useState(false);
    const [errorData, setErrorData] = useState('');
    const [errorType, setErrorType] = useState('');
    const [certTitleTabs, setCertTitleTabs] = useState([]);
    const [firmaRemotaCerts, setFirmaRemotaCerts] = useState([]);
    const [keyVaultCerts, setKeyVaultCerts] = useState([]);
    const [redTrustCerts, setRedTrustCerts] = useState([]);
    const [softwareCerts, setSoftwareCerts] = useState([]);
    const [uanatacaCerts, setUanatacaCerts] = useState([]);
    const [nebulaCerts, setNebulaCerts] = useState([]);
    const [validatedIDCerts, setValidatedIDCerts] = useState([]);
    const [ivnosysCerts, setIvnosysCerts] = useState([]);
    const [showDeleteSoftwareModal, setShowDeleteSoftwareModal] = useState(false);
    const [showDeleteKeyVaultModal, setShowDeleteKeyVaultModal] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState({});
    const [userCertsAllowed, setUserCertsAllowed] = useState({});
    const [userCertificateTypes, setUserCertificateTypes] = useState({});
    const [certDeleted, setCertDeleted] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [loadingCertificates, setLoadingCertificates] = useState(true);
    const [loadingDeletingProcess, setLoadingDeletingProcess] = useState(false);
    const [keyVaultCertb64, setKeyVaultCertb64] = useState("");
    const [KValias, setKValias] = useState("");
    const [KVpassword, setKVpassword] = useState("");
    const [KVpasswordConfirmation, setKVpasswordConfirmation] = useState("");
    const [KVpwIsInvalid, setKVpwIsInvalid] = useState(false);
    const [errorMessageKVpw, setErrorMessageKVpw] = useState("");
    const [dataUpdated, setDataUpdated] = useState(false);
    const [loadingFRcert, setLoadingFRcert] = useState(false);
    const [loadingRTcert, setLoadingRTcert] = useState(false);
    const [loadingRTsync, setLoadingRTsync] = useState(false);
    const [loadingUTcert, setLoadingUTcert] = useState(false);
    const [loadingFRUnAuth, setLoadingFRUnAuth] = useState(false);
    const [loadingRTUnAuth, setLoadingRTUnAuth] = useState(false);
    const [loadingUTUnAuth, setLoadingUTUnAuth] = useState(false);
    const [loadingVIcert, setLoadingVIcert] = useState(false);
    const [loadingVIUnAuth, setLoadingVIUnAuth] = useState(false);
    const [userIsLoggedByAuthCerts, setUserIsLoggedByAuthCerts] = useState(false);
    const [showJumbotron, setShowJumbotron] = useState(true);
    const [tabKey, setTabKey] = useState("");
    const [RedTrustIsAuthorized, setRedTrustIsAuthorized] = useState(false);
    const [FirmaRemotaIsAuthorized, setFirmaRemotaIsAuthorized] = useState(false);
    const [fileName, setFileName] = useState("");
    const [loadingCertificateTypes, setLoadingCertificateTypes] = useState(true);
    const [nebulaStep1, setNebulaStep1] = useState(true);
    const [nebulaStep2, setNebulaStep2] = useState(false);
    const [nebulaStep3, setNebulaStep3] = useState(false);
    const [NBauthenticator, setNBauthenticator] = useState("");
    const [pinChanged, setPinChanged] = useState(false);
    const [userData, setUserData] = useState(undefined);
    const [sessionExpired, setSessionExpired] = useState(false);
    const [loadingKVcert, setLoadingKVcert] = useState(false);
    const [loadingNB, setLoadingNB] = useState(false);

    // ── Refs (instance variables) ────────────────────────────────────────────
    const timerRef = useRef(null);
    const authenticatorsRef = useRef([]);
    const fileInputRef = useRef(null);
    // Keep a ref in sync with tabKey so async promise chains always read the latest value
    const tabKeyRef = useRef("");
    // Keep a ref in sync with userData so methods called inside .then() read the latest value
    const userDataRef = useRef(undefined);

    // ── Loading-key → setter map (for handleOperationError dynamic key) ───────
    const loadingSetters = {
        [LOADING_DELETING_PROCESS_KEY]: setLoadingDeletingProcess,
        [KEYVAULT_LOADING_DELETING_KEY]: setLoadingDeletingProcess,
        [KEYVAULT_LOADING_UPLOAD_KEY]: setLoadingKVcert,
        [FIRMAREMOTA_LOADING_AUTHORIZE_KEY]: setLoadingFRcert,
        [FIRMAREMOTA_LOADING_UNAUTHORIZE_KEY]: setLoadingFRUnAuth,
        [REDTRUST_LOADING_AUTHORIZE_KEY]: setLoadingRTcert,
        [REDTRUST_LOADING_UNAUTHORIZE_KEY]: setLoadingRTUnAuth,
        [REDTRUST_LOADING_SYNCHRONIZE_KEY]: setLoadingRTsync,
        [UANATACA_LOADING_AUTHORIZE_KEY]: setLoadingUTcert,
        [UANATACA_LOADING_UNAUTHORIZE_KEY]: setLoadingUTUnAuth,
        [NEBULA_LOADING_KEY]: setLoadingNB,
        [VALIDATEDID_LOADING_AUTHORIZE_KEY]: setLoadingVIcert,
        [VALIDATEDID_LOADING_UNAUTHORIZE_KEY]: setLoadingVIUnAuth,
    };

    // ── Helpers to keep refs in sync with state ───────────────────────────────
    const updateTabKey = (key) => {
        tabKeyRef.current = key;
        setTabKey(key);
    };

    const updateUserData = (data) => {
        userDataRef.current = data;
        setUserData(data);
    };

    // ── Methods ───────────────────────────────────────────────────────────────

    const startTimer = () => {
        timerRef.current = setInterval(() => setTime(prev => prev + 1), 60000);
    };

    const stopTimer = () => {
        clearInterval(timerRef.current);
    };

    const doLogOut = () => {
        sessionStorage.clear();
        stopTimer();
        setRedirect(true);
    };

    const getViDMobileUserGUIDFromOauthToken = () => {
        var tokenParts = oauthTokenB64.split(".");
        var jsonTokenInfo = atob(tokenParts[1]);
        var tokenInfo = JSON.parse(jsonTokenInfo);
        return tokenInfo.sub;
    };

    const loadUserData = () => {
        return ProfileService.getUserData()
            .then(res => {
                return res.data;
            })
            .catch(function (error) {
                if (error.response && error.response.status === 401) {
                    setSessionExpired(true);
                    startTimer();
                } else if (error.response) {
                    setErrorType(error.response.status);
                    setErrorData(error.response.data);
                    setShowError(true);
                }
                throw error;
            });
    };

    // legalid is passed explicitly to avoid stale closure on userData state
    const getUserCertificates = (legalid) => {
        return CertificateService.getUserCertificates(legalid)
            .then(res => {
                return res.data;
            })
            .catch(function (error) {
                if (error.response && error.response.status === 401) {
                    setSessionExpired(true);
                    startTimer();
                }
                if (error.response && error.response.status === 404) {
                    setLoadingCertificates(false);
                    return [];
                }

                if (error.response) {
                    setErrorType(error.response.status);
                    setErrorData(error.response.data);
                    setShowError(true);
                }

                throw error;
            });
    };

    const loadViDMobileUserCertificateTypes = () => {
        setLoadingCertificateTypes(true);

        return CertificateService.getCertificateTypes()
            .then(res => {
                setLoadingCertificateTypes(false);
                return res.data;
            })
            .catch(function (error) {
                if (error.response && error.response.status === 401) {
                    setSessionExpired(true);
                    startTimer();
                } else if (error.response) {
                    setErrorType(error.response.status);
                    setErrorData(error.response.data);
                    setShowError(true);
                }
                setLoadingCertificateTypes(false);
                throw error;
            });
    };

    const checkRedTrustStatus = () => {
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

        return new Promise(function (resolve, reject) {
            getManagementSignature(generateRedTrustAuthStatusUri(ViDMobileUserGUID), null, oauthTokenB64)
                .then(res => {
                    resolve(res.data);
                })
                .catch(function (error) {
                    if (error.response.status === 401) {
                        setSessionExpired(true);
                        startTimer();
                    } else if (error.response.status !== 409) {
                        setErrorType(error.response.status);
                        setErrorData(error.response.data);
                        setShowError(true);
                    }
                    reject(error);
                });
        });
    };

    const checkFirmaRemotaStatus = () => {
        return new Promise(function (resolve, reject) {
            getManagementSignature(generateFirmaRemotaStatusUri(), "", oauthTokenB64)
                .then(res => {
                    resolve(res.data);
                })
                .catch(function (error) {
                    if (error.response.status === 401) {
                        setSessionExpired(true);
                        startTimer();
                    } else if (error.response.status !== 409) {
                        setErrorType(error.response.status);
                        setErrorData(error.response.data);
                        setShowError(true);
                    }
                    reject(error);
                });
        });
    };

    const handleClose = () => {
        setShowDeleteSoftwareModal(false);
        setShowDeleteKeyVaultModal(false);
        setLoadingDeletingProcess(false);
    };

    const handleOperationError = (error, loadingKey) => {
        if (loadingSetters[loadingKey]) loadingSetters[loadingKey](false);

        if (error.response.status === 401) {
            setSessionExpired(true);
            startTimer();
            handleClose(); //TODO: GESTIONAR MEJOR
            return;
        }

        var errorDataValue = error.response.data;
        if (error.response.data.includes('Token not found') || error.response.data.includes('Error connecting to Uanataca')) {
            errorDataValue = t('login.invalid-login');
        }
        setErrorType(error.response.status);
        setErrorData(errorDataValue);
        setShowError(true);
    };

    const loadViDMobileUserCertificateList = () => {
        setLoadingCertificates(true);
        loadUserData()
            .then(res => {
                if (res) {
                    updateUserData(res);
                    // Pass legalid from the local `res` to avoid stale closure on userData state
                    getUserCertificates(res.legalid)
                        .then(certs => {
                            loadViDMobileUserCertificateTypes()
                                .then(types => {
                                    setUserCertificateTypes(types);
                                    var userCertsAllowedNew = [];
                                    if (types === null) {
                                        userCertsAllowedNew.push("Software");
                                    } else {
                                        for (var key1 in types) {
                                            if (typeof types[key1] === "boolean") {
                                                /**User has credentials for that certificate */
                                                if (types[key1] === true) {
                                                    userCertsAllowedNew.push(key1);
                                                }
                                            }
                                        }

                                        var certTitleTabsNew = userCertsAllowedNew.map((certificate, index) => {
                                            const certificateDisplayNames = {
                                                ValidatedID: 'Validated ID',
                                                FirmaRemota: 'itAgile'
                                            };
                                            const displayName = certificateDisplayNames[certificate] || certificate;
                                            if (certificate === "FirmaRemota") {
                                                return <Nav.Item key={certificate}>
                                                    <Nav.Link eventKey={certificate}>TrustPRO</Nav.Link>
                                                </Nav.Item>
                                            }
                                            else {
                                                return <Nav.Item key={certificate}>
                                                    <Nav.Link eventKey={certificate}>{displayName}</Nav.Link>
                                                </Nav.Item>
                                            }
                                        });

                                        var certificatesOrderedNew = {
                                            FirmaRemota: [],
                                            KeyVault: [],
                                            RedTrust: [],
                                            Software: [],
                                            Uanataca: [],
                                            Nebula: [],
                                            ValidatedID: [],
                                            Ivnosys: []
                                        };

                                        for (var certType in types) {
                                            if (typeof types[certType] === "boolean" && types[certType]) {
                                                // Use `certs` (local variable) instead of userCertificates state to avoid stale closure
                                                for(var i=0; i < certs.length; i++){
                                                    var certificate = certs[i];
                                                    if (certificate.CertType === certType){
                                                        // Map IsWalletLinked to WalletAuthorization for KeyVault certificates
                                                        if (certType === "KeyVault") {
                                                            certificate = {
                                                                ...certificate,
                                                                WalletAuthorization: certificate.IsWalletLinked
                                                            };
                                                        }
                                                        certificatesOrderedNew[certType].push(certificate);
                                                    }
                                                }
                                            }
                                        }

                                        setCertTitleTabs(certTitleTabsNew);
                                        setFirmaRemotaCerts(certificatesOrderedNew.FirmaRemota);
                                        setKeyVaultCerts(certificatesOrderedNew.KeyVault);
                                        setRedTrustCerts(certificatesOrderedNew.RedTrust);
                                        setSoftwareCerts(certificatesOrderedNew.Software);
                                        setUanatacaCerts(certificatesOrderedNew.Uanataca);
                                        setNebulaCerts(certificatesOrderedNew.Nebula);
                                        setValidatedIDCerts(certificatesOrderedNew.ValidatedID);
                                        setIvnosysCerts(certificatesOrderedNew.Ivnosys);
                                        setUserCertsAllowed(userCertsAllowedNew);
                                        updateTabKey(tabKeyRef.current !== "" ? tabKeyRef.current : userCertsAllowedNew[0]);
                                        setLoadingCertificates(false);

                                        checkRedTrustStatus()
                                            .then(res => {
                                                setRedTrustIsAuthorized(res.IsAuthorized);
                                                checkFirmaRemotaStatus()
                                                    .then(res => {
                                                        setFirmaRemotaIsAuthorized(res.IsAuthorized);
                                                    })
                                                    .catch(function (error) {
                                                        setLoadingCertificates(false);
                                                    });
                                            })
                                            .catch(function (error) {
                                                checkFirmaRemotaStatus()
                                                    .then(res => {
                                                        setFirmaRemotaIsAuthorized(res.IsAuthorized);
                                                    })
                                                    .catch(function (error) {
                                                        setLoadingCertificates(false);
                                                    });
                                            });
                                    }
                                })
                                .catch(function (error) {
                                    setLoadingCertificates(false);
                                });
                        })
                        .catch(function (error) {

                            loadViDMobileUserCertificateTypes()
                                .then(types => {
                                    setUserCertificateTypes(types);
                                    var userCertsAllowedNew = [];
                                    if (types === null) {
                                        userCertsAllowedNew.push("Software");
                                    } else {
                                        for (var key1 in types) {
                                            if (typeof types[key1] === "boolean") {
                                                /**User has credentials for that certificate */
                                                if (types[key1] === true) {
                                                    userCertsAllowedNew.push(key1);
                                                }
                                            }
                                        }

                                        var certTitleTabsNew = userCertsAllowedNew.map((certificate, index) => {
                                            return <Nav.Item key={certificate}>
                                                <Nav.Link
                                                    eventKey={certificate}>{certificate}</Nav.Link>
                                            </Nav.Item>
                                        });

                                        setCertTitleTabs(certTitleTabsNew);
                                        setFirmaRemotaCerts([]);
                                        setKeyVaultCerts([]);
                                        setRedTrustCerts([]);
                                        setSoftwareCerts([]);
                                        setUanatacaCerts([]);
                                        setNebulaCerts([]);
                                        setValidatedIDCerts([]);
                                        setIvnosysCerts([]);
                                        setUserCertsAllowed(userCertsAllowedNew);
                                        updateTabKey(tabKeyRef.current !== "" ? tabKeyRef.current : userCertsAllowedNew[0]);
                                        setLoadingCertificates(false);

                                        checkRedTrustStatus()
                                            .then(res => {
                                                setRedTrustIsAuthorized(res.IsAuthorized);
                                                checkFirmaRemotaStatus()
                                                    .then(res => {
                                                        setFirmaRemotaIsAuthorized(res.IsAuthorized);
                                                    })
                                                    .catch(function (error) {
                                                        console.log(error);
                                                        setLoadingCertificates(false);
                                                    });
                                            })
                                            .catch(function (error) {
                                                console.log(error)
                                                checkFirmaRemotaStatus()
                                                    .then(res => {
                                                        setFirmaRemotaIsAuthorized(res.IsAuthorized);
                                                    })
                                                    .catch(function (error) {
                                                        console.log(error);
                                                        setLoadingCertificates(false);
                                                    });
                                            });
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    setLoadingCertificates(false);
                                });
                        });
                } else {
                    //no user data
                }
            })
            .catch(function (error) {
                setLoadingCertificates(false);
            });
    };

    const updateCertsTypes = () => {
        const currentUserCertificateTypes = userCertificateTypes;
        const legalid = userDataRef.current ? userDataRef.current.legalid : userData && userData.legalid;
        
        for(var certType in currentUserCertificateTypes)
        {
            if(certType.toLowerCase() === VIDMOBILEUSERID)
                currentUserCertificateTypes[certType] = null;
            if(certType.toLowerCase() === SOFTWARE)
                currentUserCertificateTypes[certType] = false;
        }

        CertificateService.updateCertificateTypes(legalid, currentUserCertificateTypes)
            .then(res => {
                loadViDMobileUserCertificateList();
            })
            .catch(function (error) {
                if (error.response && error.response.status === 401) {
                    setSessionExpired(true);
                    startTimer();
                } else if (error.response) {
                    setErrorType(error.response.status);
                    setErrorData(error.response.data);
                    setShowError(true);
                }
            });
    };

    const deleteSoftwareCertificate = () => {
        const legalid = userDataRef.current ? userDataRef.current.legalid : userData && userData.legalid;
        setLoadingDeletingProcess(true);
        setShowDeleteSoftwareModal(false);

        deleteManagementSignature(generateDeleteSoftwareCertificateUri(legalid, selectedCertificate.GUID), "", oauthTokenB64)
            .then(res => {
                updateCertsTypes();
                handleClose();
                setCertDeleted(true);
            })
            .catch(function (error) {
                handleOperationError(error, LOADING_DELETING_PROCESS_KEY); 
            });
    };

    const deleteKeyVaultCertificate = () => {
        const legalid = userDataRef.current ? userDataRef.current.legalid : userData && userData.legalid;
        setLoadingDeletingProcess(true);
        setShowDeleteKeyVaultModal(false);

        deleteManagementSignature(generateDeleteKeyVaultCertificateUri(legalid, selectedCertificate.GUID), "", oauthTokenB64)
            .then(res => {
                handleOperationSuccess(res.status, KEYVAULT);
            })
            .catch(function (error) {
                handleOperationError(error, KEYVAULT_LOADING_DELETING_KEY);
            });
    };

    const handleOperationSuccess = (status, signatureName) => {
        if(signatureName === KEYVAULT)
        {
            loadViDMobileUserCertificateList();
            handleClose();
            setCertDeleted(true);
        }

        if(signatureName === REDTRUST){
            checkRedTrustStatus()
            .then(res => {
                loadViDMobileUserCertificateList();
                setRedTrustIsAuthorized(res.IsAuthorized);
                setLoadingRTcert(false);
                setDataUpdated(true);
            })
            .catch(function (error) {
                handleOperationError(error, REDTRUST_LOADING_AUTHORIZE_KEY);
            });
        }

        if(signatureName === UANATACA)
        {
            loadViDMobileUserCertificateList();
            setLoadingUTcert(false);
            setLoadingUTUnAuth(false);
            setDataUpdated(true);
        }

        if(signatureName === VALIDATEDID)
        {
            loadViDMobileUserCertificateList();
            setLoadingVIcert(false);
            setLoadingVIUnAuth(false);
            setDataUpdated(true);
        }
    };

    const uploadCertificateKeyVault = () => {
        const legalid = userDataRef.current ? userDataRef.current.legalid : userData && userData.legalid;
        setLoadingKVcert(true);

        if ((KVpassword === KVpasswordConfirmation) && KVpassword !== "" && KVpasswordConfirmation !== "") {

            const dataJson = {
                p12: keyVaultCertb64,
                certalias: KValias,
                pin: KVpassword,
                certtype: "KeyVault",
                dynamicpin: false
            };

            postManagementSignature(generateuUploadCertificateKeyVaultUri(legalid), dataJson, oauthTokenB64)
                .then(res => {
                    loadViDMobileUserCertificateList();
                    setLoadingKVcert(false);
                    setKeyVaultCertb64('');
                    setKVpassword('');
                    setKVpasswordConfirmation('');
                    setKValias('');
                    setDataUpdated(true);
                    setFileName("");
                })
                .catch(function (error) {
                    handleOperationError(error, KEYVAULT_LOADING_UPLOAD_KEY);
                });
        } else {
            setKVpwIsInvalid(true);
            setErrorMessageKVpw(t('profile.password-error'));
            setLoadingKVcert(false);
        }
    };

    const handleFileSelection = (e) => {
        var certificateFile = e.target.files[0];
        var filenameRaw = certificateFile.name;
        setFileName(filenameRaw);
        var regExpWhiteSpace = new RegExp(" ", "g");
        var filename = filenameRaw.replace(regExpWhiteSpace, "_");
        var indexExt = filename.lastIndexOf(".");
        var ext = "";
        if (indexExt > 0) {
            ext = filename.substring(indexExt + 1);
        }
        if (ext.toUpperCase() === "P12" || ext.toUpperCase() === "PFX") {
            var reader = new FileReader();
            reader.onload = function () {
                var b64NewCertificate = reader.result;
                b64NewCertificate = b64NewCertificate.substring((b64NewCertificate.indexOf(',') + 1));
                setKeyVaultCertb64(b64NewCertificate);
            };
            reader.readAsDataURL(certificateFile);
        }
    };

    const deleteKeyVault = (value, data) => {
        setShowDeleteKeyVaultModal(value);
        setSelectedCertificate(data);
    };

    const handleKeyVaultChange = (key, value, isInvalid) => {
        const setters = {
            KVpassword: setKVpassword,
            KValias: setKValias,
            KVpasswordConfirmation: setKVpasswordConfirmation,
            KeyVault: setKeyVaultCerts,
        };
        if (setters[key]) setters[key](value);
        if (isInvalid !== null) setKVpwIsInvalid(isInvalid);
    };

    const authorizeFirmaremotaCertificate = (credentialsData) => {
        setLoadingFRcert(true);

        const dataJson = {
            Username: credentialsData.FRuser,
            Password: credentialsData.FRpassword,
            Otp: ""
        };

        postManagementSignature(generateFirmaRemotaAuthUri(), dataJson, oauthTokenB64)
            .then(res => {
                checkFirmaRemotaStatus()
                    .then(res => {
                        setLoadingFRcert(false);
                        setDataUpdated(true);
                        setFirmaRemotaIsAuthorized(res.IsAuthorized);
                        loadViDMobileUserCertificateList();
                    })
                    .catch(function (error) {
                        handleOperationError(error, FIRMAREMOTA_LOADING_AUTHORIZE_KEY);
                    });
            })
            .catch(function (error) {  
                handleOperationError(error, FIRMAREMOTA_LOADING_AUTHORIZE_KEY);
            });
    };

    const unauthorizeFirmaremotaCertificate = () => {
        setLoadingFRUnAuth(true);

        deleteManagementSignature(generateFirmaRemotaAuthUri(), "", oauthTokenB64)
            .then(res => {
                loadViDMobileUserCertificateList();
                setLoadingFRUnAuth(false);
                setDataUpdated(true);
            })
            .catch(function (error) {
                handleOperationError(error, FIRMAREMOTA_LOADING_UNAUTHORIZE_KEY);
            });
    };

    const authorizeRedTrustCertificate = (credentials) => {
        const {RTuser, RTpassword, RTdomain} = credentials;
        var vidMobileUserGuid = getViDMobileUserGUIDFromOauthToken();
        
        setLoadingRTcert(true);

        const dataJson = {
            Username: RTuser,
            Password: RTpassword,
            Domain: RTdomain
        };
        
        postPrivSignature(generateRedTrustAuthUri(vidMobileUserGuid), dataJson, oauthTokenB64)
            .then(res => {
                handleOperationSuccess(res.status, REDTRUST);
            })
            .catch(function (error) {
                handleOperationError(error, REDTRUST_LOADING_AUTHORIZE_KEY);                
            });
    };

    const unauthorizeRedTrustCertificate = () => {
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
        setLoadingRTUnAuth(true);

        deleteManagementSignature(generateRedTrustAuthUri(ViDMobileUserGUID), "", oauthTokenB64)
            .then(res => {
                loadViDMobileUserCertificateList();
                setLoadingRTUnAuth(false);
                setDataUpdated(true);
            })
            .catch(function (error) {
                handleOperationError(error, REDTRUST_LOADING_UNAUTHORIZE_KEY);
            });
    };

    const synchronizeRedTrustCertificates = (credentials) => {
        const {RTuser, RTpassword, RTdomain} = credentials;
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
        setLoadingRTsync(true);

        const dataJson = {
            Username: RTuser,
            Password: RTpassword,
            Domain: RTdomain
        };

        putPrivSignature(generateRedTrustAuthUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
            .then(res => {
                checkRedTrustStatus()
                    .then(res => {
                        setLoadingRTsync(false);
                        setDataUpdated(true);
                        setRedTrustIsAuthorized(res.IsAuthorized);
                        loadViDMobileUserCertificateList();
                    })
                    .catch(function (error) {
                        console.log(error);
                        setLoadingCertificates(false);
                    });
            })
            .catch(function (error) {
                handleOperationError(error, REDTRUST_LOADING_SYNCHRONIZE_KEY);
            });
    };

    const authorizeUanatacaCertificate = (credencials) => {
        var vidMobileUserGuid = getViDMobileUserGUIDFromOauthToken();
        setLoadingUTcert(true);

        const dataJson = {
            Username: credencials.UTuser,
            Password: credencials.UTpassword,
        };
        
        postManagementSignature(generateUanatacaAuthUri(vidMobileUserGuid), dataJson, oauthTokenB64)
            .then(res => {
                handleOperationSuccess(res.status, UANATACA);
            })
            .catch(function (error) {
                handleOperationError(error, UANATACA_LOADING_AUTHORIZE_KEY);                
            });
    };

    const unauthorizeUanatacaCertificate = () => {
        var vidMobileUserGuid = getViDMobileUserGUIDFromOauthToken();
        setLoadingUTUnAuth(true);

        deleteManagementSignature(generateUanatacaAuthUri(vidMobileUserGuid), "", oauthTokenB64)
            .then(res => {
                handleOperationSuccess(res.status, UANATACA);
            })
            .catch(function (error) {
                handleOperationError(error, UANATACA_LOADING_UNAUTHORIZE_KEY);                
            });
    };

    const authorizeValidatedIdCertificate = (credencials) => {
        var vidMobileUserGuid = getViDMobileUserGUIDFromOauthToken();
        setLoadingVIcert(true);

        const dataJson = {
            Username: credencials.UTuser,
            Password: credencials.UTpassword,
        };

        postManagementSignature(generateValidatedIdAuthUri(vidMobileUserGuid), dataJson, oauthTokenB64)
            .then(res => {
                handleOperationSuccess(res.status, VALIDATEDID);
            })
            .catch(function (error) {
                handleOperationError(error, VALIDATEDID_LOADING_AUTHORIZE_KEY);
            });
    };

    const unauthorizeValidatedIdCertificate = () => {
        var vidMobileUserGuid = getViDMobileUserGUIDFromOauthToken();
        setLoadingVIUnAuth(true);

        deleteManagementSignature(generateValidatedIdAuthUri(vidMobileUserGuid), "", oauthTokenB64)
            .then(res => {
                handleOperationSuccess(res.status, VALIDATEDID);
            })
            .catch(function (error) {
                handleOperationError(error, VALIDATEDID_LOADING_UNAUTHORIZE_KEY);
            });
    };

    // Rule 2: sendAuthenticator accepts an optional override to avoid stale closure
    // when called immediately after setNBauthenticator in the Nebula flow
    const sendAuthenticator = (authenticatorOverride) => {
        const authenticator = authenticatorOverride !== undefined ? authenticatorOverride : NBauthenticator;
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
        setLoadingNB(true);

        const dataJson = {
            Authenticator: authenticator,
        };
  
        postManagementSignature(generateNebulaAuthMiddleUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
            .then(res => {
                setNebulaStep1(false);
                setNebulaStep2(false);
                setNebulaStep3(true);
                setLoadingNB(false);
            })
            .catch(function (error) {
                handleOperationError(error, NEBULA_LOADING_KEY);
            });
    };

    const sendCredentialsAndGetAuthenticators = (credentials) => {
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
        setLoadingNB(true);

        const dataJson = {
            Client: credentials.NBClient,
            Username: credentials.NBuser,
            Password: credentials.NBpassword,
        };
  
        postManagementSignature(generateNebulaAuthUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
            .then(res => {
                authenticatorsRef.current = res.data.Authenticators;

                if (authenticatorsRef.current.length === 1) {
                    setNebulaStep1(false);
                    setNebulaStep2(false);
                    setNBauthenticator(authenticatorsRef.current[0]);
                    // Pass value directly (Rule 2: setter is async, state would be stale)
                    sendAuthenticator(authenticatorsRef.current[0]);
                } else {
                    setNebulaStep1(false);
                    setNebulaStep2(true);
                    setLoadingNB(false);
                }
            })
            .catch(function (error) {
                handleOperationError(error, NEBULA_LOADING_KEY);
            });
    };

    const sendChallenge = (credentials) => {
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
        setLoadingNB(true);

        const dataJson = {
            Challenge: credentials.NBChallenge,
        };
  
        postManagementSignature(generateNebulaAuthEndUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
            .then(res => {
                loadViDMobileUserCertificateList();
                setNebulaStep1(false);
                setNebulaStep2(false);
                setNebulaStep3(false);
                setLoadingNB(false);
            })
            .catch(function (error) {
                if (error.response.status === 401) {
                    setSessionExpired(true);
                    setLoadingNB(false);
                    startTimer();
                } else {
                    setErrorType(error.response.status);
                    setErrorData(error.response.data);
                    setShowError(true);
                    setLoadingNB(false);
                }
            });
    };

    const unauthorizeNebulaCertificate = () => {
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
        setLoadingNB(true);

        CertificateService.unauthorizeNebulaCertificate(ViDMobileUserGUID)
            .then(res => {
                loadViDMobileUserCertificateList();
                setLoadingNB(false);
                setDataUpdated(true);
            })
            .catch(function (error) {
                handleOperationError(error, NEBULA_LOADING_KEY);
            });
    };

    const handleAuthenticatorChange = (key, value) => {
        const setters = {
            nebulaStep2: setNebulaStep2,
            nebulaStep3: setNebulaStep3,
            NBauthenticator: setNBauthenticator,
        };
        if (setters[key]) setters[key](value);
    };

    const handleSelect = (key) => {
        const newTabs = userCertsAllowed.map((certificate) => {
            return <Nav.Item key={certificate}>
                <Nav.Link eventKey={certificate}>{certificate === "FirmaRemota" ? "TrustPRO": certificate}</Nav.Link>
            </Nav.Item>
        });
        setCertTitleTabs(newTabs);
        updateTabKey(key);
    };

    const getLoadingModalTitle = () => {
        if (loadingDeletingProcess) return t('certificates.delete-process');
        if (loadingKVcert) return t('certificates.kv-create-process');
        if (loadingFRcert) return t('certificates.fr-create-process');
        if (loadingUTcert) return t('certificates.ut-create-process');
        if (loadingFRUnAuth) return t('certificates.fr-delete-process');
        if (loadingRTcert) return t('certificates.rt-create-process');
        if (loadingRTUnAuth) return t('certificates.rt-delete-process');
        if (loadingUTUnAuth) return t('certificates.ut-delete-process');
        if (loadingRTsync) return t('certificates.rt-sync-process');
        if (loadingNB) return t('login.loading');
        if (loadingVIcert) return t('certificates.vi-create-process');
        if (loadingVIUnAuth) return t('certificates.vi-delete-process');
    };

    // ── componentDidMount ────────────────────────────────────────────────────
    useEffect(() => {
        ThemeService.setTheme();

        var authCerts = sessionStorage.getItem('authCerts');
        if (authCerts !== null) {
            setUserIsLoggedByAuthCerts(true);
        }
        loadViDMobileUserCertificateList();

        const params = new URLSearchParams(window.location.search);

        // Check Ivnosys authorization success
        const ivnosysAuthorization = params.get('ivnosysAuthorization');

        if (ivnosysAuthorization) {
            // open Ivnosys tab
            updateTabKey('Ivnosys');
        }

        const tabParam = params.get('tab');
        if (tabParam) {
            updateTabKey(tabParam);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ── Render ───────────────────────────────────────────────────────────────

    var timeText = language === 'es' ? 'Hace ' + time + ' minutos' : language === 'en' ? time + ' minutes ago' : language === 'ca' ? 'Fa ' + time + ' minuts' : 'Hace ' + time + ' minutos';
    
    const isLoading = loadingDeletingProcess || loadingKVcert || loadingFRcert || loadingRTcert || loadingUTcert ||
        loadingRTsync || loadingFRUnAuth || loadingRTUnAuth || loadingUTUnAuth || loadingNB || loadingVIcert || loadingVIUnAuth;

    if (redirect) {
        return <Redirect to={{
            pathname: '/'
        }}
        />;
    }
    if (userIsLoggedByAuthCerts) {
        return <Redirect to={{
            pathname: '/authcerts'
        }}
        />;
    }

    const certsNotAvailable = <p>{t('certificates.certificate-not-available')}</p>;

    const refreshCertificatesComponent = <RefreshIcon className="refresh-icon" onClick={() => loadViDMobileUserCertificateList()} />;

    // parentState mirrors the class's this.state for child components that consume it
    const parentState = {
        oauthTokenB64,
        language,
        time,
        showError,
        errorData,
        errorType,
        certTitleTabs,
        certificatesOrdered: {
            FirmaRemota: firmaRemotaCerts,
            KeyVault: keyVaultCerts,
            RedTrust: redTrustCerts,
            Software: softwareCerts,
            Uanataca: uanatacaCerts,
            Nebula: nebulaCerts,
            ValidatedID: validatedIDCerts,
            Ivnosys: ivnosysCerts,
        },
        showDeleteSoftwareModal,
        showDeleteKeyVaultModal,
        selectedCertificate,
        userCertsAllowed,
        userCertificateTypes,
        certDeleted,
        redirect,
        loadingCertificates,
        loadingDeletingProcess,
        keyVaultCertb64,
        KValias,
        KVpassword,
        KVpasswordConfirmation,
        KVpwIsInvalid,
        errorMessageKVpw,
        dataUpdated,
        loadingFRcert,
        loadingRTcert,
        loadingRTsync,
        loadingUTcert,
        loadingFRUnAuth,
        loadingRTUnAuth,
        loadingUTUnAuth,
        loadingVIcert,
        loadingVIUnAuth,
        userIsLoggedByAuthCerts,
        showJumbotron,
        tabKey,
        RedTrustIsAuthorized,
        FirmaRemotaIsAuthorized,
        fileName,
        loadingCertificateTypes,
        nebulaStep1,
        nebulaStep2,
        nebulaStep3,
        NBauthenticator,
        pinChanged,
        userData,
        sessionExpired,
        loadingKVcert,
        loadingNB,
    };

    return (
        <div>
            <Header />
            {showJumbotron &&
                <Jumbotron>
                    <MdClose className="close-jumbotron"
                        onClick={() => setShowJumbotron(v => !v)} />
                    <div className="jumbotron-content">
                        <img src={warning} alt="Warning icon"/>
                        <p>{t('certificates.certificates')}. &nbsp;
                        {
                            !loadingCertificates && !loadingCertificateTypes &&
                            (
                                !userCertificateTypes ?
                                    certsNotAvailable :
                                        t('certificates.certificates-available')
                            )
                        }
                        </p>
                    </div>
                </Jumbotron>
            }
            {dataUpdated && (
                <ToastComponent
                    onClose={() => setDataUpdated(false)}
                    show={dataUpdated}
                    autohide
                    delay={3000}
                    title={t('certificates.task-completed')}
                    message={t('certificates.task-completed-text')}
                    variant="success"
                    zIndex={10}
                    position="absolute"
                />
            )}
            {showError &&
                <ToastComponent
                    onClose={() => setShowError(false)}
                    show={showError}
                    title={<>{t('general.error')} {errorType}</>}
                    message={errorData}
                    variant="error"
                    closeButton
                    zIndex={11}
                />
            }
            {sessionExpired &&
                <ToastComponent
                    show={sessionExpired}
                    title={t('general.notification')}
                    subtitle={timeText}
                    variant="session-expired"
                    zIndex={10}
                    closeButton={false}
                >
                    <p>{t('general.session-expired')}</p>
                    <Button
                        type="button"
                        className="btn btn-primary"
                        id="sign-all-docs"
                        onClick={() => doLogOut()}
                    >
                        {t('general.accept')}
                    </Button>
                </ToastComponent>
            }
            {certDeleted &&
                <ToastComponent
                    onClose={() => setCertDeleted(false)}
                    show={certDeleted}
                    autohide
                    delay={3000}
                    title={t('certificates.certificate-deleted')}
                    message={t('certificates.certificate-deleted-text')}
                    variant="success"
                    zIndex={10}
                />
            }
            {pinChanged &&
                <ToastComponent
                    onClose={() => setPinChanged(false)}
                    show={pinChanged}
                    autohide
                    delay={3000}
                    title={t('certificates.pin-changed')}
                    message={t('certificates.pin-changed-text')}
                    variant="success"
                    zIndex={10}
                />
            }
            {(loadingCertificates || loadingCertificateTypes) &&
                <LoadingCircle centerVertically={true} />
            }
            {!loadingCertificates && !loadingCertificateTypes && userCertificateTypes &&
                <div className="certificates-container">
                    <CustomModal
                        show={showDeleteSoftwareModal}
                        handleHide={() => handleClose()}
                        handleConfirm={() => deleteSoftwareCertificate()}
                        title={t('certificates.sw-delete')}
                        text={t('certificates.certificate-delete-text')}
                    />
                    <CustomModal
                        show={showDeleteKeyVaultModal}
                        handleHide={() => handleClose()}
                        handleConfirm={() => deleteKeyVaultCertificate()}
                        title={t('certificates.kv-delete')}
                        text={t('certificates.certificate-delete-text')}
                    />
                    <CustomModal
                        show={isLoading}
                        handleHide={() => handleClose()}
                        title={getLoadingModalTitle()}
                        loading={true}
                        closable={false}
                    />

                    <div>
                        <Tab.Container defaultActiveKey={tabKey} onSelect={(key) => handleSelect(key)}>
                            <Row>
                                <Col sm={2} bsPrefix="left-column col">
                                    <Nav variant="pills" className="flex-column cert-tabs">
                                        {certTitleTabs}
                                    </Nav>
                                </Col>
                                <Col sm={10} bsPrefix="right-column col" className='unset-position'>
                                    <Tab.Content bsPrefix="tab-content tab-content2">
                                        <Tab.Pane eventKey="Software">
                                            <SoftwareCertificates 
                                                parentState={parentState} 
                                                onCertificateDelete={(row) => { setShowDeleteSoftwareModal(true); setSelectedCertificate(row); }}>
                                                    {refreshCertificatesComponent}
                                                </SoftwareCertificates>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="KeyVault">
                                            <KeyVaultCertificates
                                                parentState={parentState}
                                                onHandleFileSelection={handleFileSelection}
                                                onUploadCertificateKeyVault={uploadCertificateKeyVault}
                                                onDeleteKeyVault={(value, data) => deleteKeyVault(value, data)}
                                                onFileInput={(ref) => { fileInputRef.current = ref; }}
                                                onHandleKeyVaultChange={(key, value, isInvalid) => handleKeyVaultChange(key, value, isInvalid)}
                                                onSuccessPinChanged={() => setPinChanged(true)}
                                                onError={(error) => { setShowError(true); setErrorType(error.status); setErrorData(error.data); }}
                                                onRefreshCertificates={() => loadViDMobileUserCertificateList()}>
                                                    {refreshCertificatesComponent}
                                            </KeyVaultCertificates>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="FirmaRemota">
                                            <FirmaRemotaCertificates 
                                                parentState={parentState}
                                                onAuthorizeFirmaremotaCertificate={authorizeFirmaremotaCertificate}
                                                onUnauthorizeFirmaremotaCertificate={unauthorizeFirmaremotaCertificate} >
                                                    {refreshCertificatesComponent}
                                                </FirmaRemotaCertificates>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="RedTrust">
                                        <RedTrustCertificates 
                                                parentState={parentState} 
                                                authorizeRedTrustCertificate={authorizeRedTrustCertificate}
                                                unauthorizeRedTrustCertificate={unauthorizeRedTrustCertificate}
                                                synchronizeRedTrustCertificates={synchronizeRedTrustCertificates}>
                                                    {refreshCertificatesComponent}
                                                </RedTrustCertificates>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Uanataca">
                                            <UanatacaCertificates
                                                parentState={parentState}
                                                onAuthorizeUanatacaCertificate={authorizeUanatacaCertificate}
                                                onUnauthorizeUanatacaCertificate={unauthorizeUanatacaCertificate}>
                                                    {refreshCertificatesComponent}
                                                </UanatacaCertificates>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="ValidatedID">
                                            <ValidatedIdCertificates
                                                parentState={parentState}
                                                onAuthorizeValidatedIdCertificate={authorizeValidatedIdCertificate}
                                                onUnauthorizeValidatedIdCertificate={unauthorizeValidatedIdCertificate}>
                                                    {refreshCertificatesComponent}
                                                </ValidatedIdCertificates>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Swisscom">
                                            <div className="table-container">
                                                {t('certificates.certificate-swisscom-available')}
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Local">
                                            <div className="table-container">
                                                {t('certificates.certificate-local-available')}
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Nebula">
                                            <NebulaCertificates 
                                                parentState={parentState} 
                                                onChangeFormControl={(key, value) => handleAuthenticatorChange(key, value)} 
                                                onSendCredentialsAndGetAuthenticators={sendCredentialsAndGetAuthenticators}
                                                onSendAuthenticator={sendAuthenticator}
                                                onSendChallenge={sendChallenge}
                                                onUnauthorizeNebulaCertificate={unauthorizeNebulaCertificate}
                                                authenticators={authenticatorsRef.current}>
                                                    {refreshCertificatesComponent}
                                                </NebulaCertificates>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Ivnosys">
                                            <IvnosysCertificates
                                                parentState={parentState}
                                                refreshCertificatesList={() => loadViDMobileUserCertificateList()}>
                                                    {refreshCertificatesComponent}
                                            </IvnosysCertificates>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            }
        </div>
    );
};

export default Certificates;
